// extracted by mini-css-extract-plugin
module.exports = {"favorite":"styles_favorite__28uyP","info":"styles_info__1hJhw"};